<div class="mapLayer__panel" (click)="$event.stopPropagation()" #customLayerController [class.show_hide]="!mapLayertoggle">
    <div class="mapLayer-panel-header">
        <b>{{"reports.map_layer" | translate}}</b>
        <button class="refreshbtn" [disabled]="resetLayerDisable()" (click)="resetLayer()" [ngStyle]="{'float': current_lang == 'en' ? 'right':'left'} ">
            <img src="../../../../../assets/images/tabler-icon-rotate-clockwise.svg" alt="Refresh">
        </button>
    </div>
    <div class="maplayer-panel-body">
        <!-- <hr class="linedivider"> -->
        <div>
            <label class="mapLegend d-flex align align-items-center" style="gap: 4px">
                <b>{{'reports.mapType' | translate}}</b> <span class="active-symbol"></span></label>
                <div class="mappanel-box">
                    <div class="map-layer d-flex align-items-center">
                        <div class="d-flex align-items-center pointer" (click)="selectedBasemap('default')">
                            <span class="type-radio" [ngClass]="{'selected_option': basemap_select == 'default'}">
                                <i *ngIf="basemap_select == 'default'" class="circle"></i>
                            </span>
                            <p>{{"reports.default" | translate}}</p>
                        </div>
                    </div>
                    <div class="map-layer">
                        <div class="d-flex align-items-center pointer" (click)="selectedBasemap('satellite', true)">
                            <span class="type-radio" [ngClass]="{'selected_option': basemap_select == 'satellite'}">
                                <i *ngIf="basemap_select == 'satellite'" class="circle"></i>
                            </span>
                            <p>{{"reports.satellite" | translate}}</p>
                        </div>
                    </div>
                </div>
        </div>
        <div>
            <label class="mapLegend d-flex align align-items-center" style="gap: 4px">
                <b>{{"Cluster" | translate}} </b>
            <span class="active-symbol"></span>
            </label>
                <div class="mappanel-box">
                            <div class="map-layer legends_layers d-flex align-items-center"  *ngIf="is_transaction_table; else elseRental">
                                <div  class="d-flex align-items-center">
                                    <input type="checkbox" id="cluster-label"  (change)="toggleCluster($event)" [value]="isClusterActive" [checked]="isClusterActive || isClusterDisabled" [disabled]="isClusterDisabled">
                                    <p [matTooltip]="'reports.transaction_rate' | translate" matTooltipClass="non-interactive-tooltip" matTooltipPosition="above">{{'reports.transaction_rate' | translate}}</p>
                                </div>
                            </div>
                            <ng-template #elseRental>
                                <!-- <label for="cluster-label" *ngIf="is_rental_table; else isPropertyCount">{{ 'reports.unitRentRate' | translate }}</label> -->
                                 <ng-container *ngIf="is_rental_table; else isPropertyCount">
                                    <ng-container *ngFor="let cluster of rentalClusters">
                                        <div class="map-layer">
                                            <div class="d-flex align-items-center pointer" [ngClass]="{'disabled_clusterItem' : isClusterDisabled && cluster.value == 'none'}"  (click)="clusterChange(cluster)">
                                                <span class="type-radio" [ngClass]="{'default': cluster.value == selectedCluster}" >
                                                    <i class="circle" *ngIf="cluster.value == selectedCluster"></i>
                                                </span>
                                                <p>{{ cluster.label?.[current_lang_id]}}</p>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-template>
                            <ng-template #isPropertyCount>
                                <div class="map-layer legends_layers d-flex align-items-center">
                                    <div  class="d-flex align-items-center">
                                        <input type="checkbox" id="cluster-label"  (change)="toggleCluster($event)" [value]="isClusterActive" [checked]="isClusterActive || isClusterDisabled" [disabled]="isClusterDisabled">
                                        <p *ngIf="is_rental_table">{{"Property Count" | translate}}</p>
                                        <p>{{"Property Count" | translate}}</p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    <!-- </div> -->
                <!-- </div> -->
        </div>
        <!-- <hr class="linedivider"> -->
        <ng-container *ngIf="legendLayerGroup?.length > 0">
            <label class="mapLegend">
                <b>{{"reports.parcel_fill" | translate}}</b></label>
                <div class="mappanel-box">
            <ng-container *ngFor="let legend of legendLayerGroup; let i = index">
                <div class="map-layer d-flex legends_layers" *ngIf="legend.status">
                    <div class="d-flex align-items-center pointer" [class.disabled_legend1]="!isParcelActive">
                        <!-- <input type="checkbox" [value]="legend.legend_type" [checked]="legend.display" [id]="'legend_' + legend.legend_type" (change)="debouncedLegendChange(legend)" [disabled]="!isParcelActive"> -->
                        <input type="checkbox" [value]="legend.legend_type" [checked]="legend.display" [id]="'legend_' + legend.legend_type" (change)="debouncedLegendChange(legend)">
                        <label [for]="'legend_' + legend.legend_type" [matTooltip]="(legend.label?.[current_lang_id] && legend.label?.[current_lang_id]?.length > 13)?legend.label[current_lang_id]:(legend.label[1] && legend.label[1].length > 13) ? legend.label[1]:''" matTooltipClass="non-interactive-tooltip"  matTooltipPosition="above">{{legend.label?.[current_lang_id]?legend.label[current_lang_id]:legend.label[1]}}</label>
                    </div>
                    <span class="active-symbol" *ngIf="mapZoom >= 16"></span>
                </div>
            </ng-container>
            </div>
        </ng-container>
        <!-- <hr class="linedivider"> -->
        <div>
            <label class="mapLegend">
                <b>{{"reports.Attributes" | translate}}</b></label>
                <div class="mappanel-box">
            <ng-container *ngFor="let map_layer of mapLayers; let i = index">
                
                <div class="map-layer d-flex" *ngIf="map_layer?.layer_status">
                    <div class="d-flex align-items-center pointer" (click)="selectedLayers(map_layer)">
                        <span class="type-mult-check-box"[ngClass]="{'selected_option': map_layer.display}">
                            <svg *ngIf="map_layer.display" class="check-box"  width="6" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.5 1.125L3.0625 4.5625L1.5 3" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>                                
                        </span>
                        <!-- <p class="maplayer-box" [matTooltip]="map_layer?.showToolTip ? (map_layer.label | translate) : ''">{{map_layer.label | translate}}</p> -->
                        <p class="maplayer-box" [matTooltip]="map_layer?.showToolTip ? map_layer.label?.[current_lang_id]?map_layer.label[current_lang_id]:map_layer.label[1] : ''" matTooltipClass="non-interactive-tooltip"  matTooltipPosition="above">{{map_layer.label?.[current_lang_id]?map_layer.label[current_lang_id]:map_layer.label[1]}}</p>
                    </div>
                    <!-- Active Cricle to show when mapZoom is between minZoom and maxZoom -->
                    <span class="active-symbol" *ngIf="mapZoom >= map_layer?.minZoom && mapZoom <= map_layer?.maxZoom"></span>
                </div>
            </ng-container>
            </div>
        </div>
    </div>
</div>
